import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'showMore',
  standalone: true
})
export class ShowMorePipe implements PipeTransform {
  transform(items, limit: number, showAll: boolean) {
    if (!items) {
      return []
    }
    return showAll ? items : items.slice(0, limit)
  }
}
